const NUM_START_WITH_VOWEL = [8, 11, 18, 80];
export const getArticle = maxColors => {
  return NUM_START_WITH_VOWEL.includes(maxColors) ? 'an' : 'a';
};